export default "__VITE_ASSET__jhlQonvp__"